import { FC } from "react";
import {
  SHEET_FOOTER_CTAS_DEFAULTS,
  SHEET_FOOTER_CTAS_DIRECTION_CLASS_MAP,
  SHEET_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP,
  TSheetFooterCtaProps,
} from "./Sheet.config";
import { Button } from "../../primitives";
import { cn } from "@/ui/lib";

export const SheetFooterCtas: FC<TSheetFooterCtaProps> = ({
  align = SHEET_FOOTER_CTAS_DEFAULTS.align, ctas,
}) => {
  if (!ctas) { return null; }
  return (
    <div
      data-component="SheetFooterCtas"
      className={cn(
        "flex gap-2",
        SHEET_FOOTER_CTAS_DIRECTION_CLASS_MAP[align],
      )}
    >
      { ctas.primary ? (
        <Button {...ctas.primary} width={SHEET_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP[align]} />
      ) : null }
      { ctas.secondary ? (
        <Button {...ctas.secondary} variant="tertiary" width={SHEET_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP[align]} />
      ) : null }
    </div>
  );
};
